var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-center align-items-center" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Ver detalle",
                  expression: "'Ver detalle'"
                }
              ]
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn-icon rounded-circle p-3",
                  attrs: {
                    "data-cy": "details",
                    variant: "secondary",
                    size: "sm"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onOptionDetailAuction(_vm.auction, "visualize")
                    }
                  }
                },
                [_c("feather-icon", { attrs: { icon: "SearchIcon" } })],
                1
              )
            ],
            1
          ),
          _vm._t(
            "action-list",
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Desplegar acciones",
                      expression: "'Desplegar acciones'"
                    }
                  ]
                },
                [
                  _c(
                    "b-dropdown",
                    {
                      directives: [
                        {
                          name: "has-permission",
                          rawName: "v-has-permission",
                          value: "ED191",
                          expression: "'ED191'"
                        }
                      ],
                      attrs: {
                        "data-cy": "gear-button",
                        variant: "link",
                        "no-caret": "",
                        right: ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "button-content",
                          fn: function() {
                            return [
                              _c("feather-icon", {
                                staticClass: "align-middle text-body",
                                attrs: {
                                  width: "24px",
                                  height: "24px",
                                  icon: "SettingsIcon"
                                }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED180" } },
                        [
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "binnacle" },
                              on: {
                                click: function($event) {
                                  return _vm.onOptionBinnacle(_vm.auction)
                                }
                              }
                            },
                            [
                              _c("vs-icon", { attrs: { icon: "list" } }),
                              _vm._v(" Bitácora ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED178" } },
                        [
                          _vm.auction.estado ===
                          _vm.auctionsStateCode.preparacion
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: { "data-cy": "add-batch" },
                                  on: {
                                    click: function($event) {
                                      return _vm.openBatchForm(_vm.auction)
                                    }
                                  }
                                },
                                [
                                  _c("vs-icon", { attrs: { icon: "add" } }),
                                  _vm._v(" Agregar Lote ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED176" } },
                        [
                          _vm.canPlanify
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: { "data-cy": "planning-auction" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onOptionDetailAuction(
                                        _vm.auction,
                                        "edit"
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("vs-icon", {
                                    attrs: { icon: "content_paste" }
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.auction.estado ===
                                          _vm.auctionsStateCode.preparacion
                                          ? "Planificar"
                                          : "Re-Planificar"
                                      ) +
                                      " "
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED192" } },
                        [
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "batches" },
                              on: {
                                click: function($event) {
                                  return _vm.goToBatchesFiltered(_vm.auction)
                                }
                              }
                            },
                            [
                              _c("vs-icon", { attrs: { icon: "search" } }),
                              _vm._v(" Ver Lotes ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED193" } },
                        [
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "receipts" },
                              on: {
                                click: function($event) {
                                  return _vm.goToReceiptsFiltered(_vm.auction)
                                }
                              }
                            },
                            [
                              _c("vs-icon", { attrs: { icon: "search" } }),
                              _vm._v(" Ver Comprobantes ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED177" } },
                        [
                          _vm.auction.estado === _vm.auctionsStateCode.publicada
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: {
                                    "data-cy": "auction-update-finalize"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.showUpdateAuctionAlert(
                                        _vm.auctionsActionStates.FINALIZAR
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("vs-icon", {
                                    attrs: { icon: "check_circle" }
                                  }),
                                  _vm._v(" Finalizar ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm.auction.estado === _vm.auctionsStateCode.planificada
                        ? _c(
                            "CheckPermission",
                            { attrs: { permission: "ED194" } },
                            [
                              _c(
                                "b-dropdown-item",
                                {
                                  attrs: {
                                    "data-cy": "auction-update-publish"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.showUpdateAuctionAlert(
                                        _vm.auctionsActionStates.PUBLICAR
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("vs-icon", {
                                    attrs: { icon: "verified_user" }
                                  }),
                                  _vm._v(" Publicar ")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.auction.estado === _vm.auctionsStateCode.creada
                        ? _c(
                            "CheckPermission",
                            { attrs: { permission: "ED216" } },
                            [
                              _vm.auction.estado ===
                              _vm.auctionsStateCode.creada
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        "data-cy": "auction-update-prepare"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.showUpdateAuctionAlert(
                                            _vm.auctionsActionStates.PREPARAR
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("vs-icon", {
                                        attrs: { icon: "arrow_forward" }
                                      }),
                                      _vm._v(" Preparar ")
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.auction.estado === _vm.auctionsStateCode.preparacion
                        ? _c(
                            "CheckPermission",
                            { attrs: { permission: "ED217" } },
                            [
                              _vm.auction.estado ===
                              _vm.auctionsStateCode.preparacion
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        "data-cy": "auction-update-un-prepare"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.showUpdateAuctionAlert(
                                            _vm.auctionsActionStates.DESPREPARAR
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("vs-icon", {
                                        attrs: { icon: "arrow_back" }
                                      }),
                                      _vm._v(" Dejar de preparar ")
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED179" } },
                        [
                          _vm.auction.estado === _vm.auctionsStateCode.publicada
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: { "data-cy": "auction-update-cancel" },
                                  on: {
                                    click: function($event) {
                                      return _vm.showUpdateAuctionAlert(
                                        _vm.auctionsActionStates.CANCELAR
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("vs-icon", { attrs: { icon: "clear" } }),
                                  _vm._v(" Cancelar ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED156" } },
                        [
                          _vm.auction.estado ===
                            _vm.auctionsStateCode.finalizada ||
                          _vm.auction.estado === _vm.auctionsStateCode.cancelada
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: { "data-cy": "auction-view-history" },
                                  on: {
                                    click: function($event) {
                                      return _vm.goToAuctionHistory(_vm.auction)
                                    }
                                  }
                                },
                                [
                                  _c("vs-icon", { attrs: { icon: "search" } }),
                                  _vm._v(" Ver Historial ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED156" } },
                        [
                          _vm.auction.estado ===
                            _vm.auctionsStateCode.finalizada ||
                          _vm.auction.estado === _vm.auctionsStateCode.cancelada
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: {
                                    "data-cy": "auction-download-history"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onDownloadAuction(_vm.auction)
                                    }
                                  }
                                },
                                [
                                  _c("vs-icon", {
                                    attrs: { icon: "file_download" }
                                  }),
                                  _vm._v(" Descargar Historial ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("span")
                ],
                1
              )
            ],
            { auction: _vm.auction }
          )
        ],
        2
      ),
      _c(
        "b-modal",
        {
          ref: "receipt-detail-" + _vm.auction.id,
          attrs: {
            id: "receipt-detail-" + _vm.auction.id,
            title: "Detalles de subasta Nº " + _vm.auction.folio,
            "no-close-on-backdrop": "",
            size: "lg",
            "hide-footer": ""
          }
        },
        [
          _c("AuctionDetail", {
            attrs: { auction: _vm.auction, action: _vm.action },
            on: {
              reload: _vm.handleReload,
              "update-auction-status": _vm.updateAuctionFromModal,
              "update-auction-status-show-modal": _vm.updateAuction
            }
          })
        ],
        1
      ),
      _c("ModalBinnacle", {
        ref: "binnacle-" + _vm.auction.subastaId,
        attrs: {
          auction: _vm.auction,
          title: "Bitácora de la subasta Nº " + _vm.auction.folio,
          id: "binnacle-" + _vm.auction.subastaId
        }
      }),
      _c(
        "b-modal",
        {
          ref: "add-batch-" + _vm.auction.id,
          attrs: {
            id: "add-batch-" + _vm.auction.id,
            title: "Agregar lotes a la subasta Nº " + _vm.auction.folio,
            "no-close-on-backdrop": "",
            size: "lg",
            "hide-footer": ""
          }
        },
        [
          _c("AuctionDetail", {
            attrs: { auction: _vm.auction, action: _vm.action },
            on: {
              "update-auction-status": _vm.updateAuctionFromModal,
              "update-auction-status-show-modal": _vm.updateAuction
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }